import { render, staticRenderFns } from "./SingleScansPaymentHistory.vue?vue&type=template&id=5e20b5e3"
import script from "./SingleScansPaymentHistory.vue?vue&type=script&lang=js"
export * from "./SingleScansPaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./SingleScansPaymentHistory.vue?vue&type=style&index=0&id=5e20b5e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports